const dynamicOfferHash = (baseUrl) => {
  const url = [ baseUrl, "dynamic_offer_hash" ].join("/");
  return {
    bau: {
      launchImage: `${url}/bau/launch_image.png`
    },
    bauImage: {
      plansImage: `${url}/bau_image/plans_image.png`
    },
    conceptCarousel: {
      launchImage: `${url}/concept_carousel/launch_image.png`,
      mainPlanImage: `${url}/concept_carousel/main_plan_image.png`,
      phonesImage: `${url}/concept_carousel/phones.png`
    }
  };
};

export default dynamicOfferHash;
